var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-table', {
    staticClass: "cartTable",
    attrs: {
      "items": _vm.tableItems,
      "fields": _vm.tableFields,
      "responsive": "sm"
    },
    scopedSlots: _vm._u([{
      key: "cell(product)",
      fn: function (data) {
        return [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('img', {
          staticClass: "table-product-image img-fluid",
          attrs: {
            "src": data.item.images ? data.item.images.smallImage : data.item.imageLink,
            "alt": "Product Image"
          }
        }), _c('div', [_c('div', {
          staticClass: "product-name"
        }, [_vm._v(" " + _vm._s(data.item.description_summary && data.item.description_summary.length > 20 ? data.item.Name : data.item.description_summary) + " ")]), data.item._id != '67f0bd1458eeb6f746342b34' ? _c('div', {
          staticClass: "product-brand"
        }, [_vm._v(" " + _vm._s(data.item.Brand) + " ")]) : _vm._e()])])];
      }
    }, {
      key: "cell(price)",
      fn: function (data) {
        return [_c('h6', {
          staticClass: "text-icon price-normal mb-0"
        }, [_vm._v(" " + _vm._s(_vm.currency.symbol) + _vm._s(Number(data.item.Price).toFixed(2)) + " " + _vm._s(_vm.currency.code) + " ")])];
      }
    }, {
      key: "cell(quantity)",
      fn: function (data) {
        return [_c('checkout-increment-decrement', {
          attrs: {
            "callCheckout": true,
            "cartItem": data.item
          }
        })];
      }
    }, {
      key: "cell(total)",
      fn: function (data) {
        return [_c('h6', {
          staticClass: "text-icon price-normal mb-0"
        }, [_vm._v(" " + _vm._s(_vm.currency.symbol) + _vm._s(Number(data.item.unitAmount).toFixed(2)) + " " + _vm._s(_vm.currency.code) + " ")])];
      }
    }, {
      key: "cell(action)",
      fn: function (data) {
        return [data.item._id != '67f0bd1458eeb6f746342b34' ? _c('button', {
          staticClass: "remove-btn",
          on: {
            "click": function ($event) {
              return _vm.removeItemFromCart(data);
            }
          }
        }, [_c('b-icon-x-circle')], 1) : _vm._e()];
      }
    }])
  }), _c('div', {
    staticClass: "mobile-cart-view d-md-none"
  }, _vm._l(_vm.tableItems, function (item) {
    return _c('div', {
      key: item._id,
      staticClass: "mobile-cart-item"
    }, [_c('div', {
      staticClass: "mobile-row"
    }, [_c('div', {
      staticClass: "mobile-label"
    }, [_vm._v(_vm._s(_vm.$t("cartItem.product")))]), _c('div', {
      staticClass: "mobile-value d-flex align-items-center"
    }, [_c('img', {
      staticClass: "table-product-image",
      attrs: {
        "src": item.images ? item.images.smallImage : item.imageLink,
        "alt": "Product Image"
      }
    }), _c('div', {
      staticClass: "ml-2"
    }, [_c('div', {
      staticClass: "product-name"
    }, [_vm._v(" " + _vm._s(item.description_summary && item.description_summary.length > 20 ? item.Name : item.description_summary) + " ")]), item._id !== '67f0bd1458eeb6f746342b34' ? _c('div', {
      staticClass: "product-brand"
    }, [_vm._v(" " + _vm._s(item.Brand) + " ")]) : _vm._e()])])]), _c('div', {
      staticClass: "mobile-row"
    }, [_c('div', {
      staticClass: "mobile-label"
    }, [_vm._v(_vm._s(_vm.$t("cartItem.price")))]), _c('div', {
      staticClass: "mobile-value text-icon price-normal mb-0"
    }, [_vm._v(" " + _vm._s(_vm.currency.symbol) + " " + _vm._s(Number(item.Price).toFixed(2)) + " " + _vm._s(_vm.currency.code) + " ")])]), _c('div', {
      staticClass: "mobile-row"
    }, [_c('div', {
      staticClass: "mobile-label"
    }, [_vm._v(_vm._s(_vm.$t("cartItem.quantity")))]), _c('div', {
      staticClass: "mobile-value quantityDelete"
    }, [_c('checkout-increment-decrement', {
      attrs: {
        "callCheckout": true,
        "cartItem": item
      }
    }), item._id !== '67f0bd1458eeb6f746342b34' ? _c('button', {
      staticClass: "remove-btn",
      on: {
        "click": function ($event) {
          return _vm.removeItemFromCart({
            item
          });
        }
      }
    }, [_c('b-icon-archive')], 1) : _vm._e()], 1)]), _c('div', {
      staticClass: "mobile-row"
    }, [_c('div', {
      staticClass: "mobile-label"
    }, [_vm._v(_vm._s(_vm.$t("cartItem.subTotal")))]), _c('div', {
      staticClass: "mobile-value text-icon price-normal mb-0"
    }, [_vm._v(" " + _vm._s(_vm.currency.symbol) + _vm._s(Number(item.unitAmount).toFixed(2)) + " " + _vm._s(_vm.currency.code) + " ")])])]);
  }), 0)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }